// @ts-ignore no type
window.pipwerks = require("./SCORM_API_wrapper");
